import { useDispatch, useSelector } from "react-redux";
import FilterPillButton from "../FilterPillButton";
import styles from "./Filters.module.scss";
import ToolTip from "../OnboardingPopup/components/ToolTip";
import { FAVOURITES_VIEW } from "../../constants";
import { sendAnalyticsEvent } from "../../lib/postMessage";
import { FAVOURITES, VIEW } from "../../constants/analytics";

const Filters = () => {
  const dispatch = useDispatch();
  const { onboardingStep, storedFavourites } = useSelector(
    (state) => state.filter
  );
  const { loggedIn, experiments } = useSelector((state) => state.view);
  // If the emptyFavouritesState experiment is enabled, we want to show the favourites button even if the user is not logged in
  // and they have no previously stored favourites
  const showFavouritesButton =
    Boolean(
      loggedIn && experiments?.favouritesEnabled && storedFavourites.length > 0
    ) || Boolean(experiments?.emptyFavouritesState);

  const fixturesTabLabel = experiments?.showCompetitionLabel
    ? "Competitions"
    : "Fixtures";

  const handleFiltersHighlightedClassName = () => {
    if (onboardingStep === 2) {
      return "filters--highlighted";
    }

    return "";
  };

  const handleFiltersContainerHighlightedClassName = () => {
    if (onboardingStep === 2) {
      return "filtersContainer--highlighted";
    }

    return "";
  };

  const goToFavourites = () => {
    dispatch({
      type: "SET_ACTIVE_FILTER_VIEW",
      payload: FAVOURITES_VIEW,
    });

    sendAnalyticsEvent({
      event: FAVOURITES,
      type: FAVOURITES_VIEW.charAt(0).toUpperCase() + FAVOURITES_VIEW.slice(1),
      action: VIEW,
    });
  };

  return (
    <div
      className={`${styles.filters} ${
        styles[`${handleFiltersHighlightedClassName()}`]
      }`}
    >
      <div
        className={`${styles.filtersContainer} ${
          styles[`${handleFiltersContainerHighlightedClassName()}`]
        }`}
      >
        <FilterPillButton name="Odds" />
        <FilterPillButton name="Date" />
        <FilterPillButton name="Fixtures" label={fixturesTabLabel} />
        <FilterPillButton name="Markets" />
      </div>
      {showFavouritesButton && (
        <div className={styles.favouritesButtonContainer}>
          <button type="button" onClick={goToFavourites}>
            Favourites
          </button>
        </div>
      )}
      {/* If onboarding is active then we show the ToolTip relative to the filtersContainer */}
      {onboardingStep === 2 ? <ToolTip /> : null}
    </div>
  );
};

export default Filters;
